import React, { useState, useCallback } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import CruiseItinerary from './CruiseItinerary'
import ItineraryMap from './ItineraryMap'
import Group from 'components/utils/Group'
import { mediaQueryUp } from 'components/utils/breakpoint'

const ItineraryArea = styled.div`
  flex-grow: 1;
  order: 2;

  ${mediaQueryUp.tablet} {
    order: 1;
  }
`

interface Props {
  itinerary: Array<App.CruiseItineraryItem>
  cruiseType: App.CruiseType
}

function CruiseItineraryAndMap(props: Props) {
  const { itinerary, cruiseType } = props
  const intl = useIntl()
  const [portNameSelected, setPortName] = useState<string | undefined>(undefined)
  const [itineraryKey, setItineraryKey] = useState<string | undefined>(undefined)
  const [map, setMap] = useState<google.maps.Map | undefined>(undefined)

  const onSelectAccordionItem = useCallback((port?: App.CruisePort, itineraryKey?: string) => {
    if (port && map) {
      setPortName(port.name)
      setItineraryKey(itineraryKey)

      // centralize map on port selected on accordion
      const { latitude, longitude } = port
      const latLng = new google.maps.LatLng(Number(latitude), Number(longitude))

      map.setZoom(5)
      map.panTo(latLng)
    }
  }, [map])

  const onSelectMapItem = useCallback((portName: string) => {
    setPortName(portName)
    setItineraryKey(undefined)
  }, [])

  return <Group direction="vertical" tabletDirection="horizontal" verticalAlign="start" gap={16}>
    <ItineraryArea data-testid="itinerary-area">
      <CruiseItinerary
        itinerary={itinerary}
        title={intl.formatMessage({
          id: '8cSiL6Ylux9I8Hb-TVWA',
          defaultMessage: 'What you’ll see',
          description: 'Title for cruise itinerary section in the cruise offer or booking section',
        })}
        portNameSelected={portNameSelected}
        itineraryKeySelected={itineraryKey}
        cruiseType={cruiseType}
        onSelectPort={onSelectAccordionItem}
      />
    </ItineraryArea>

    <ItineraryMap
      itinerary={itinerary}
      portNameSelected={portNameSelected}
      onSelectPort={onSelectMapItem}
      onMapLoaded={setMap}
    />
  </Group>
}

export default CruiseItineraryAndMap
